import { ReactNode } from "react";

interface IPhoneFrameProps {
  children: ReactNode;
}

export function IPhoneFrame({ children }: IPhoneFrameProps) {
  return (
    <div className="relative w-[280px]">
      <div className="absolute -left-[2px] top-[80px] w-[2px] h-8 bg-gray-300 rounded-l-sm" />
      <div className="absolute -left-[2px] top-[120px] w-[2px] h-8 bg-gray-300 rounded-l-sm" />
      <div className="absolute -right-[2px] top-[100px] w-[2px] h-12 bg-gray-300 rounded-r-sm" />

      <div className="rounded-[40px] border-[2px] border-gray-300 bg-black p-[6px]">
        <div className="relative h-[560px] rounded-[34px] bg-gray-100 overflow-hidden">
          <div className="flex items-center justify-between px-6 pt-3 pb-2">
            <span className="text-[12px] font-medium text-gray-900">9:41</span>
            <div className="flex items-center gap-1">
              <div className="flex gap-[2px]">
                <div className="w-[3px] h-[3px] bg-gray-900 rounded-full" />
                <div className="w-[3px] h-[3px] bg-gray-900 rounded-full" />
                <div className="w-[3px] h-[3px] bg-gray-900 rounded-full" />
                <div className="w-[3px] h-[3px] bg-gray-400 rounded-full" />
              </div>
              <div className="ml-1 w-6 h-3 border border-gray-900 rounded-sm relative">
                <div className="absolute inset-[2px] right-1.5 bg-gray-900 rounded-[1px]" />
                <div className="absolute -right-[3px] top-[2px] w-[3px] h-[6px] bg-gray-900 rounded-r-sm" />
              </div>
            </div>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
}
